import { render, staticRenderFns } from "./FlowDetail.vue?vue&type=template&id=645b13bd&scoped=true"
import script from "./FlowDetail.vue?vue&type=script&lang=js"
export * from "./FlowDetail.vue?vue&type=script&lang=js"
import style0 from "./FlowDetail.vue?vue&type=style&index=0&id=645b13bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b13bd",
  null
  
)

export default component.exports